import * as React from 'react';
import { Button, Form, Header, Image, GridRow, Segment } from 'semantic-ui-react';

import configs from '../helpers/config';
import LinkButton from './LinkButton';

class LoginMedico extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...configs.DEFAULT_MEDICO };
        this.inputs = [];
    }

    handleLogin() {
        const { codigo, senha } = this.state;

        if (codigo && senha) {
            this.props.onClick({ ...this.state });
            this.setState({ ...configs.DEFAULT_MEDICO });
        } else {
            alert('Insira a os dados de acesso corretamente');
        }
    }

    render() {
        return (
            <Segment className={this.props.className}>

                <Header as='h2'  >

                    <p className='headerLogin'><Image src={require('../img/medico2.png')} className='imgLogoLoginMedico' size='mini' avatar />MÉDICO</p>
                </Header>

                <Form size='large'>
                    <GridRow >
                        <Form.Input
                            fluid
                            icon='user'
                            iconPosition='left'
                            placeholder='Login ou email'
                            value={this.state.codigo}
                            onChange={(e) => this.setState({ ...this.state, codigo: e.target.value })}
                        />
                        <Form.Input
                            fluid
                            icon='lock'
                            iconPosition='left'
                            placeholder='Senha'
                            value={this.state.senha}
                            type='password'
                            onChange={(e) => this.setState({ ...this.state, senha: e.target.value })}
                        />

                        <Button fluid size='large' onClick={() => this.handleLogin()}>
                            ENTRAR
                        </Button >
                        <br />
                        <LinkButton onClick={this.props.recuperar} >Esqueci minha senha</LinkButton>
                    </GridRow>
                </Form>

            </Segment>);
    }
}

export default LoginMedico;
